var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1230,
    height: 20,
    viewBox: "0 0 1230 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1230,
    height: 19.475,
    fill: "url(#pattern0_936_2074)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_936_2074",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_936_2074",
    transform: "matrix(0.000854701 0 0 0.0539811 0 -0.0128205)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_936_2074",
    width: 1170,
    height: 19,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABJIAAAATCAYAAADLTidxAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAEkqADAAQAAAABAAAAEwAAAAAW7YcLAAAB1UlEQVR4Ae3YQQ3AIBQFQUBO1aKvZkpSA6yA4co/Td5p57Pfb3gECBAgQIAAAQIECBAgQIAAAQIELgLr8u+bAAECBAgQIECAAAECBAgQIECAwC8gJBkCAQIECBAgQIAAAQIECBAgQIBAEhCSEpMjAgQIECBAgAABAgQIECBAgAABIckGCBAgQIAAAQIECBAgQIAAAQIEkoCQlJgcESBAgAABAgQIECBAgAABAgQICEk2QIAAAQIECBAgQIAAAQIECBAgkASEpMTkiAABAgQIECBAgAABAgQIECBAQEiyAQIECBAgQIAAAQIECBAgQIAAgSQgJCUmRwQIECBAgAABAgQIECBAgAABAkKSDRAgQIAAAQIECBAgQIAAAQIECCQBISkxOSJAgAABAgQIECBAgAABAgQIEBCSbIAAAQIECBAgQIAAAQIECBAgQCAJCEmJyREBAgQIECBAgAABAgQIECBAgICQZAMECBAgQIAAAQIECBAgQIAAAQJJQEhKTI4IECBAgAABAgQIECBAgAABAgSEJBsgQIAAAQIECBAgQIAAAQIECBBIAkJSYnJEgAABAgQIECBAgAABAgQIECAgJNkAAQIECBAgQIAAAQIECBAgQIBAEjim8AK5WXIpqgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopImage);
export default __webpack_public_path__ + "static/media/top_image.8d824273704155c163403cf6635fedde.svg";
export { ForwardRef as ReactComponent };